import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Disabled, DisabledButton } from "../../../../Constant";
import { Btn } from "../../../../AbstractElements";
import CommonRaisedButton from "../Common/CommonRaisedButton";
import { RAISED_DISABLE_BUTTONS, RAISED_DISABLE_BUTTONS_LIST } from "../../../../Data/Buttons/RaisedStyle";

const RaisedDisabledButtons = () => {
  return (
    <Card>
      <CommonCardHeader title={DisabledButton} span={RAISED_DISABLE_BUTTONS} />
      <CardBody className="btn-showcase">
        <Btn disabled color="primary" className="btn-pill btn-air-primary">{Disabled}</Btn>
        {RAISED_DISABLE_BUTTONS_LIST.map((data, index) => (
          <CommonRaisedButton key={index} item={data} disabled />
        ))}
      </CardBody>
    </Card>
  );
};

export default RaisedDisabledButtons;
